import step0 from '@/store/modules/invoicesIssuing/step0Issuer'
import step1 from '@/store/modules/invoicesIssuing/step1Receiver'
import step2 from '@/store/modules/invoicesIssuing/step2Detail'
import step3 from '@/store/modules/invoicesIssuing/step3Others'
import step4 from '@/store/modules/invoicesIssuing/step4Line'
import step5 from '@/store/modules/invoicesIssuing/step5Totals'
import step6 from '@/store/modules/invoicesIssuing/step6Payment'
import step7 from '@/store/modules/invoicesIssuing/step7Attachments'

const ISSUING_TYPES = { FACTURA: 1, PROFORMA: 2, PRESUPUESTO: 3, SIMPLIFICADA: 4 }

const getDefaultState = () => {
  return {
    curStep: 0,
    summaryCollapsed: true,
    entityCreation: false,
    issuingTypes: ISSUING_TYPES,
    issuingType: ISSUING_TYPES.FACTURA
  }
}

const state = getDefaultState()
const getters = {
  curStep: state => state.curStep,
  isSummaryCollapsed: state => !!state.summaryCollapsed,
  isEntityCreation: state => !!state.entityCreation,
  issuingTypes: state => state.issuingTypes,
  issuingType: state => state.issuingType,
  issuingTypeStr: state => Object.entries(ISSUING_TYPES).map(([key, id]) => ({ id, key })).find(x => x.id === state.issuingType)?.key ?? null,
  isInIssuingType: state => issuingType => state.issuingType === issuingType,
  form: state => Object.values(state).reduce((acc, x) => ({ ...acc, ...x.form }), {}),
  impuestos: (state, getters) => {
    const invoiceLines = getters.form?.invoiceLines ?? []
    const taxZero = getters.form?.tipoImpuestoFactura ?? null
    return invoiceLines.flatMap(line => line.taxes.map(tax => ({
      id: `${tax.TaxType} - ${tax.TaxRate}`,
      BaseImponible: line.total,
      Clase: tax.TaxType,
      Tipo: tax.TaxRate,
      Cuota: taxZero ? 0 : tax.cuota,
      Total: line.totalConImpuesto
    }))).reduce((acc, tax) => {
      const aux = acc.find(tax1 => tax1.id === tax.id)
      if (aux) {
        aux.BaseImponible += tax.BaseImponible
        aux.Cuota += tax.Cuota
        aux.Total += tax.Total
      } else {
        acc.push(tax)
      }
      return acc
    }, [])
  },
  lineas: (state, getters) => {
    const invoiceLines = getters.form?.invoiceLines ?? []
    return invoiceLines.map(line => ({
      NumeroLinea: line.lineNumber,
      Descripcion: line.descripcion,
      Cantidad: line.cantidad,
      Total: line.totalConImpuesto
    }))
  }
}
const mutations = {
  setCurStep (state, curStep) {
    state.curStep = curStep
  },
  setSummaryCollapsed (state, expanded) {
    state.summaryCollapsed = !!expanded
  },
  setEntityCreation (state, value) {
    state.entityCreation = !!value
  },
  setIssuingType (state, type) {
    if (typeof type !== 'number') {
      let key = ''
      if (typeof type !== 'string') {
        key = String(type)
      }
      key = type.toUpperCase().replaceAll(/[ -]/, '_')
      type = ISSUING_TYPES[key] || ISSUING_TYPES.FACTURA
    }
    state.issuingType = type
  },
  setMasterFilters (state, master) {
    this.commit('invoicesIssuing/0/setMasterFilters', master, { root: true })
  },
  resetMasterFilters (state) {
    this.commit('invoicesIssuing/0/resetMasterFilters', undefined, { root: true })
  }
}
const actions = {
  nextStep ({ commit, state }) {
    commit('setCurStep', state.curStep + 1)
  },
  previousStep ({ commit, state }) {
    commit('setCurStep', Math.max(state.curStep - 1, 0))
  },
  toogleSummaryCollapsed ({ commit, getters }) {
    commit('setSummaryCollapsed', !getters.isSummaryCollapsed)
  },
  resetForm ({ dispatch }, excluded = []) {
    for (const moduleName in modules) {
      if (!excluded.includes(moduleName) && Object.prototype.hasOwnProperty.call(modules, moduleName)) {
        dispatch(`invoicesIssuing/${moduleName}/resetForm`, null, { root: true })
      }
    }
  }
}
const modules = {
  0: step0,
  1: step1,
  2: step2,
  3: step3,
  4: step4,
  5: step5,
  6: step6,
  7: step7
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules
}
